export default "__VITE_PUBLIC_ASSET__643e6a77__"